import { Font } from '@react-pdf/renderer';

/** @type {import('@react-pdf/types').SingleLoad} */
const font = {
  family: 'GTAmerica',
  fontWeight: 400,
  format: 'truetype',
  src: `//s3.amazonaws.com/cdn.bottlebooks.me/bottlebooks/fonts/maximeHerkunft/GTAmerica-CompressedThin.ttf`,
};

Font.register(font);

const style = { fontFamily: font.family, fontWeight: Number(font.fontWeight) };
export default style;
